import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { finalize, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { HelperService, IceapiService } from '../../../../../services/index';
import { MeasurementService } from '../../../../../services/measurement.service';
import { ScheduleModel } from '../../../models/index';
import { Router } from '@angular/router';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-pipe-schedule',
    templateUrl: './pipe-schedule.component.html',
    styleUrls: ['./pipe-schedule.component.scss'],
    standalone: false,
})
export class PipeScheduleComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Input()
    set pipeSizeId(value: string) {
        if (value) {
            this._pipeSizeId = value;
            if (!this.jointCalcService.isPipeCode) this.getPipeSchedules(value, null);
        }
    }
    get pipeSizeId(): string {
        return this._pipeSizeId;
    }

    @Input()
    set clampId(value: string) {
        if (value) {
            this._clampId = value;
            if (!this.jointCalcService.isPipeCode) this.getPipeSchedules(null, value);
        }
    }
    get clampId(): string {
        return this._clampId;
    }

    @Input()
    set isCustom(value: boolean) {
        this._isCustom = value;
    }
    get isCustom(): boolean {
        return this._isCustom;
    }
    @Output() selected: EventEmitter<ScheduleModel> = new EventEmitter();
    destroy$ = new Subject();

    tooltip_position = 'above';
    loading: boolean = false;
    optionList: ScheduleModel[];

    private _clampId: string;
    private _pipeSizeId: string;
    private _isCustom: boolean;

    constructor(
        private iceapi: IceapiService,
        private measSvc: MeasurementService,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private router: Router,
        private jointCalcService: JointCalcService
    ) {}

    ngOnInit(): void {
        if (!this.jointCalcService.isPipeCode) this.getPipeSchedules(null, null);
        else if ((this.jointCalcService.isPipeCode && this.router.url.includes('/idms/plantmanagerView')) || this.router.url == '/idms/plantmanager')
            this.pipespecwithpipeSchedule();
        this.form.markAllAsTouched();
        if (this.isCustom) {
            this.form
                .get('customPipeSchedule')
                ?.valueChanges?.pipe(takeUntil(this.destroy$))
                .subscribe((value) => {
                    if (value) {
                        this.form.get('customPipeSchedule').patchValue(this.measSvc.format(value, UnitType.DefaultLengthUnit), { emitEvent: false });
                    }
                });
        }
        this.form
            .get('pipeSchedule')
            ?.valueChanges?.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode)
                        this.jointCalcService.selectedPipeSchedule.next(value);
                }
            });
    }

    getPipeSchedules(pipeSizeId: string, clampId: string): void {
        this.form.markAllAsTouched();
        if (this.router.url != '/informate/customflange/true' && this.router.url != '/informate/customflange/false') {
            // if (!this.pipeSizeId && !this.clampId) return
            this.loading = true;

            this.iceapi
                .getPipeSchedules(pipeSizeId, clampId)
                .pipe(
                    finalize(() => {
                        this.loading = false;
                        this.cd.detectChanges();
                    }),
                    takeUntil(this.destroy$)
                )
                .subscribe((schedules) => {
                    if (schedules.success === true) {
                        this.optionList = schedules.response;
                        this.cd.markForCheck();
                        if (this.optionList.length === 1) this.form.get('pipeSchedule').setValue(this.optionList[0].pipeScheduleId);
                        if (this.form.get('pipeSchedule').value) {
                            this.dataService.selectedPipeSize = this.optionList?.find(
                                (x) => x.pipeScheduleId === this.form.get('pipeSchedule').value
                            )?.pipeScheduleName;
                        } else if (this.optionList.find((x) => x.pipeScheduleName == 'STD'))
                            this.form.get('pipeSchedule')?.setValue(this.optionList.find((x) => x.pipeScheduleName == 'STD')?.pipeScheduleId);
                    } else {
                        this.user_utility.errorModelPopup(schedules.message);
                    }
                });
        }
    }

    selectPipeSchedule(selectedValue: MatSelectChange): void {
        const selection = this.optionList.find((x) => x.pipeScheduleId === selectedValue.value);
        if (selection) {
            this.selected.emit(selection);
            this.dataService.selectedPipeSize = selection.pipeScheduleName;
        }
        this.form.markAllAsTouched();
    }

    async pipespecwithpipeSchedule() {
        this.jointCalcService.selectedclampMaterial.pipe(takeUntil(this.destroy$)).subscribe(async (cm) => {
            if (cm) {
                this.loading = true;
                const inputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;

                inputGroup.recordId.hubMaterialId = inputGroup.recordId.sealRingMaterialId = inputGroup.recordId.sealRingId = inputGroup.others.boltType = null;

                let pipePipeScedule = await this.iceapi
                    .getPipeSchedules(inputGroup.recordId.pipeSizeId, inputGroup.recordId.clampId)
                    .pipe(
                        finalize(() => {
                            this.loading = false;
                            this.cd.detectChanges();
                        })
                    )
                    .toPromise();

                if (pipePipeScedule.success) {
                    this.optionList = pipePipeScedule.response;
                    this.jointCalcService.pipeSpecpayload.lookupParams.recordId.clampMaterialId = cm;
                    this.optionList = await this.jointCalcService.managePayloadForRecourdId('pipeScheduleId', this.optionList);
                    if (
                        this.dataService?.calculationData?.input?.recordId?.pipeScheduleId &&
                        this.optionList.some((x) => x.pipeScheduleId == this.dataService?.calculationData?.input?.recordId?.pipeScheduleId)
                    )
                        this.form.get('pipeSchedule').setValue(this.dataService?.calculationData?.input?.recordId?.pipeScheduleId);
                    else if (this.optionList.length === 1) this.form.get('pipeSchedule').setValue(this.optionList[0].pipeScheduleId);
                } else if (pipePipeScedule.isCustom) {
                    this.user_utility.errorModelPopup(pipePipeScedule.message);
                }
            }
        });
        this.jointCalcService.selectedStandard.pipe(takeUntil(this.destroy$)).subscribe(async (cm) => {
            if (cm) {
                this.loading = true;
                let pipePipeScedule = await this.iceapi
                    .getPipeSchedules(null, null)
                    .pipe(
                        finalize(() => {
                            this.loading = false;
                            this.cd.detectChanges();
                        })
                    )
                    .toPromise();

                if (pipePipeScedule.success) {
                    this.optionList = pipePipeScedule.response;
                    // this.jointCalcService.pipeSpecpayload.lookupParams.recordId.standardId = cm;
                    this.optionList = await this.jointCalcService.managePayloadForRecourdId('pipeScheduleId', this.optionList);
                    if (
                        this.dataService?.calculationData?.input?.recordId?.pipeScheduleId &&
                        this.optionList.some((x) => x.pipeScheduleId == this.dataService?.calculationData?.input?.recordId?.pipeScheduleId)
                    )
                        this.form.get('pipeSchedule').setValue(this.dataService?.calculationData?.input?.recordId?.pipeScheduleId);
                    else if (this.optionList.length === 1) this.form.get('pipeSchedule').setValue(this.optionList[0].pipeScheduleId);
                } else if (pipePipeScedule.isCustom) {
                    this.user_utility.errorModelPopup(pipePipeScedule.message);
                }
            }
        });
        this.jointCalcService.selectedTighteningSpecification.pipe(takeUntil(this.destroy$)).subscribe(async (cm) => {
            if (cm) {
                this.loading = true;
                let pipePipeScedule = await this.iceapi
                    .getPipeSchedules(null, null)
                    .pipe(
                        finalize(() => {
                            this.loading = false;
                            this.cd.detectChanges();
                        })
                    )
                    .toPromise();

                if (pipePipeScedule.success) {
                    this.optionList = pipePipeScedule.response;
                    // this.jointCalcService.pipeSpecpayload.lookupParams.recordId.standardId = cm;
                    this.optionList = await this.jointCalcService.managePayloadForRecourdId('pipeScheduleId', this.optionList);
                    if (
                        this.dataService?.calculationData?.input?.recordId?.pipeScheduleId &&
                        this.optionList.some((x) => x.pipeScheduleId == this.dataService?.calculationData?.input?.recordId?.pipeScheduleId)
                    )
                        this.form.get('pipeSchedule').setValue(this.dataService?.calculationData?.input?.recordId?.pipeScheduleId);
                    else if (this.optionList.length === 1) this.form.get('pipeSchedule').setValue(this.optionList[0].pipeScheduleId);
                } else if (pipePipeScedule.isCustom) {
                    this.user_utility.errorModelPopup(pipePipeScedule.message);
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
